import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useParams } from "react-router-dom";
import { LoadingPanel } from "../../../components/layout/Loading";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { checkAcessRights, formatIndianNumber } from "../../../_helper/helper";
import { EXCEL_EXPORT_ACCESS, PRINT_ACCESS } from "../../../_contstants/common";
import AlertBox from "../../../components/common/AlertBox";
import moment from "moment";
import { GetPromocodeUsageReport } from "../services/reports.services";
import { sumBy } from "lodash";

const PromocodeUsageReportView = () => {
  const gridRef = React.useRef<any>(null);
  const dispatch = useAppDispatch();
  // const navigate = useNavigate();
  const params = useParams();
  const isExcelExportAccess = checkAcessRights(
    "/promocodeusagereportform",
    EXCEL_EXPORT_ACCESS,
  );
  const isPrintAccess = checkAcessRights(
    "/promocodeusagereportform",
    PRINT_ACCESS,
  );

  const filterFromDate = params?.filterFromDate;
  const filterToDate = params?.filterToDate;
  const filterUser = params?.filterUser;

  const loading = useAppSelector((state) => state.reports.loading);
  const PromocodeUsageListForReport = useAppSelector(
    (state) => state.reports.PromocodeUsageListForReport,
  );

  const [uiLoading, setLoading] = React.useState<boolean>(true);

  useEffect(() => {
    setLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (filterToDate && filterFromDate) {
      const payload = {
        FromDate: filterFromDate !== "0" ? filterFromDate : "",
        ToDate: filterToDate !== "0" ? filterToDate : "",
        UserID: filterUser !== "0" ? filterUser : 0,
      };
      dispatch(GetPromocodeUsageReport(payload));
    }
  }, []);

  const handleExportExcel = () => {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.table_to_sheet(
      document.querySelector(".table-bordered"),
    );
    XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, "Promocode Usage Report.xlsx");
  };

  if (uiLoading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      <div
        className="report-container"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 10px",
        }}
      >
        <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
          Promocode Usage Report{" "}
          <span style={{ fontSize: 15 }}>
            {PromocodeUsageListForReport &&
              PromocodeUsageListForReport.length > 0 &&
              `(
              ${
                filterFromDate !== "0"
                  ? moment(filterFromDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                  : ""
              }${filterFromDate !== "0" && filterToDate !== "0" ? " to " : ""}${
                filterToDate !== "0"
                  ? moment(filterToDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                  : " "
              }
              )`}
          </span>
        </Typography.h4>
        <div className="printbuttons">
          {isPrintAccess &&
            PromocodeUsageListForReport &&
            PromocodeUsageListForReport.length > 0 && (
              <Button
                style={{ marginRight: 5 }}
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={() => window.print()}
              >
                Print
              </Button>
            )}

          {isExcelExportAccess &&
            PromocodeUsageListForReport &&
            PromocodeUsageListForReport.length > 0 && (
              <Button
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={handleExportExcel}
              >
                Excel Export
              </Button>
            )}
        </div>
      </div>
      {PromocodeUsageListForReport && PromocodeUsageListForReport.length > 0 ? (
        <div className="table-responsive" style={{ margin: "0 10px" }}>
          <table className="table table-bordered reportScreens lead-report">
            <thead>
              <tr className="text-center">
                <th style={{ background: "black", color: "white" }}>No</th>
                <th style={{ background: "black", color: "white" }}>
                  Booking No.
                </th>
                <th style={{ background: "black", color: "white" }}>Name</th>
                <th style={{ background: "black", color: "white" }}>
                  Mobile No.
                </th>
                <th style={{ background: "black", color: "white" }}>
                  Email ID
                </th>
                <th style={{ background: "black", color: "white" }}>
                  Coupon Code
                </th>
                <th style={{ background: "black", color: "white" }}>
                  Coupon Code Amount
                </th>
                <th style={{ background: "black", color: "white" }}>
                  Total Amount
                </th>
              </tr>
            </thead>
            <tbody>
              {PromocodeUsageListForReport &&
                PromocodeUsageListForReport.length > 0 &&
                PromocodeUsageListForReport?.map(
                  (promocodeusage: any, index: number) => (
                    <tr key={index} className="text-center">
                      <td>{index + 1}</td>
                      <td style={{ wordBreak: "break-all" }}>
                        {promocodeusage?.BookingNo || ""}
                      </td>
                      <td className="text-start">
                        {promocodeusage?.Name || ""}
                      </td>
                      <td>{promocodeusage?.MobileNo || ""}</td>
                      <td
                        className="text-start"
                        style={{ wordBreak: "break-all", minWidth: 100 }}
                      >
                        {promocodeusage?.EmailID || ""}
                      </td>
                      <td>{promocodeusage?.CouponCode || ""}</td>
                      <td className="text-end">
                        {formatIndianNumber(
                          promocodeusage?.CouponCodeValue || 0,
                        )}
                      </td>
                      <td className="text-end">
                        {formatIndianNumber(promocodeusage?.TotalAmt || 0)}
                      </td>
                    </tr>
                  ),
                )}
              <tr className="text-end fw-600">
                <td colSpan={6}>Total</td>
                <td>
                  {formatIndianNumber(
                    sumBy(PromocodeUsageListForReport, "CouponCodeValue") || 0,
                  )}
                </td>
                <td>
                  {formatIndianNumber(
                    sumBy(PromocodeUsageListForReport, "TotalAmt") || 0,
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      ) : (
        <AlertBox style={{ margin: "0 10px 10px" }} />
      )}
    </>
  );
};

export default PromocodeUsageReportView;
